
<template>
  <div class="public-nav">
    <el-container style="height: auto">
      <!-- 侧边栏 -->
      <el-aside width="230px">
         <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-nav"
          @select="handleselect"
          @open="handleOpen"
          @close="handleClose"
          ref="menus"
          :router="true"
          text-color="#fff"
        >
        <el-submenu  index="1" v-if="hasPermission(1)" >
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="sim" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">资产管理</span>
              </div>
            </template>

              <el-submenu index="1-1"  v-if="hasPermission(322)"  class="secondary-menu">
                  <template slot="title">
                    <div class="title">
                      <div style="width:28px;"></div>
                      <span style="font-size: 14px;">自研设备</span>
                    </div>
                  </template>
                  <el-menu-item class="firstmenus" style="padding-left:90px;" v-if="hasPermission(10)" index="/assets/battery">自研设备列表</el-menu-item>
                  <el-menu-item class="firstmenus" style="padding-left:90px;" v-if="hasPermission(323)" index="/assets/changingCabinet">换电柜列表</el-menu-item>
                  <el-menu-item class="firstmenus" style="padding-left:90px;" v-if="hasPermission(324)" index="/assets/batteryIOTBMS">IOT-BMS列表</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:90px;" v-if="hasPermission(380)" index="/assets/battery/BLBMS">BL-BMS列表</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:90px;" v-if="hasPermission(367)" index="/assets/centerControl">IOT-中控列表</el-menu-item>
              </el-submenu>
              <el-menu-item-group>

                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(11)" index="/assets/grossList">SIM卡列表</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(140)" index="/assets/assetsDelete">资产删除记录</el-menu-item>
              </el-menu-item-group>
        </el-submenu>

         <el-submenu index="5" v-if="hasPermission(2)" >
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="chukuguangli" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">设备出库管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(21)" index="/assets/equipmentList">自研设备出入库</el-menu-item>
             </el-menu-item-group>

             <!-- <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(21)" index="/assets/storageEquipment">自研设备入库</el-menu-item>
             </el-menu-item-group> -->

             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(22)" index="/assets/outfieldEquipmentList">外采设备出库</el-menu-item>
             </el-menu-item-group>

              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(23)" index="/assets/cabinetDelivery">换电柜出入库</el-menu-item>
             </el-menu-item-group>

              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(24)" index="/assets/chargingDelivery">充电桩出入库</el-menu-item>
             </el-menu-item-group>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(25)" index="/assets/warningStations">预警基站出库</el-menu-item>
             </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(246)" index="/assets/equipmentOrderChange">设备订单变更</el-menu-item>
             </el-menu-item-group>
        </el-submenu>


        <el-submenu  index="13" v-if="hasPermission(363)" >
          <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="xianshang" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">设备告警管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(155)" index="/assets/equipmentAlarmList">设备告警</el-menu-item>
             </el-menu-item-group>

              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(364)" index="/assets/cabinetAlarmList">换电柜告警</el-menu-item>
             </el-menu-item-group>

              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(370)" index="/assets/centerControlAlarmList">中控告警</el-menu-item>
             </el-menu-item-group>
        </el-submenu>


         <el-menu-item index="/assets/customerList" class="firstmenus" v-if="hasPermission(3)">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="kehu" style="font-size: 30px" ></svg-icon>
                  </div>
                  <span style="font-size: 16px;">客户管理</span>
              </div>
        </el-menu-item>
           <el-menu-item index="/assets/operator" class="firstmenus" v-if="hasPermission(420)">
             <div class="title">
               <div class="icon-wrap">
                 <svg-icon icon-class="kehu" style="font-size: 30px" ></svg-icon>
               </div>
               <span style="font-size: 16px;">运营商管理</span>
             </div>
           </el-menu-item>

        <el-submenu index="2" v-if="hasPermission(4)" >
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="dingjia" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">续费管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(55)" index="/assets/fundsList">SIM卡续费</el-menu-item>
             </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3" v-if="hasPermission(5)" >
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="yujing" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">预警管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(57)" index="/assets/earlyList">超流量SIM卡</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(58)" index="/assets/simChange">SIM卡变更记录</el-menu-item>
             </el-menu-item-group>
        </el-submenu>
         <el-submenu index="4" v-if="hasPermission(6)" >
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="chuku" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">采购管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(63)" index="/assets/deliveryRecordList">SIM卡出货记录</el-menu-item>
             </el-menu-item-group>

             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(64)" index="/assets/batchManagementList">SIM卡采购记录</el-menu-item>
             </el-menu-item-group>

              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(65)" index="/assets/returnList">SIM卡退货记录</el-menu-item>
             </el-menu-item-group>

           <el-menu-item-group>
             <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(375)" index="/assets/supplierList">SIM卡供应商列表</el-menu-item>
           </el-menu-item-group>
        </el-submenu>

         <el-submenu index="6" v-if="hasPermission(7)" >
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="baofei" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">报废管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(78)" index="/assets/retirementManagement">SIM卡报废</el-menu-item>
             </el-menu-item-group>
        </el-submenu>
        <el-submenu  index="9" v-if="hasPermission(180)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="producte" style="font-size:22px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">产品管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(181)" index="/assets/ProductManagement/productType">产品类型管理</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(182)" index="/assets/ProductManagement/productModel">产品型号管理</el-menu-item>
                <!-- <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(183)" index="/assets/ProductManagement/gradeParts">配件等级管理</el-menu-item> -->
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(184)" index="/assets/ProductManagement/hardwareVersion">硬件版本管理</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(185)" index="/assets/ProductManagement/MCUFirmwareVersion">MCU固件版本管理</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(186)" index="/assets/ProductManagement/softwareVersion">软件版本管理</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(394)" index="/assets/ProductManagement/structuralVersion">结构版本管理</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(215)" index="/assets/ProductManagement/productAssembly">产品总成</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(244)" index="/assets/ProductManagement/deleteList">信息删除记录</el-menu-item>
             </el-menu-item-group>
             <el-submenu index="7"  v-if="hasPermission(114)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="yuancheng" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">远程升级</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(115)" index="/assets/remoteUpgrade/communicationModule/index">通讯模块</el-menu-item>
             </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(116)" index="/assets/remoteUpgrade/bmsUpgrade/index">BMS</el-menu-item>
             </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(117)" index="/assets/remoteUpgrade/batterCommandBatch/index">电池命令批量执行</el-menu-item>
             </el-menu-item-group>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(220)" index="/assets/remoteUpgrade/upgradingStrategy/index">升级策略</el-menu-item>
             </el-menu-item-group>
             <!-- <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(221)" index="/assets/remoteUpgrade/upgradeTask/index">升级任务</el-menu-item>
             </el-menu-item-group> -->

            <el-submenu  index="12" v-if="hasPermission(308)">
              <template slot="title">
                <div class="title">
                  <!-- <div class="icon-wrap">
                    <svg-icon icon-class="order" style="font-size: 32px" ></svg-icon>
                  </div> -->
                  <span style="margin-left:12px">升级任务管理</span>
                </div>
              </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:85px;" v-if="hasPermission(221)" index="/assets/remoteUpgrade/upgradeTask/index">升级任务</el-menu-item>
             </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:85px;" v-if="hasPermission(391)" index="/assets/remoteUpgrade/newUpgradeTask/index">推送升级任务</el-menu-item>
              </el-menu-item-group>

             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:85px;" v-if="hasPermission(309)" index="/assets/orderUpgrade">订单待升级任务</el-menu-item>
             </el-menu-item-group>

            <el-menu-item-group>
             <el-menu-item class="firstmenus" style="padding-left:85px;" v-if="hasPermission(311)" index="/assets/ProductManagement/params">上位机参数</el-menu-item>
           </el-menu-item-group>
        </el-submenu>
        </el-submenu>
        </el-submenu>

         <el-submenu  index="10" v-if="hasPermission(209)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="shengc" style="font-size:26px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">生产管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(210)" index="/assets/Technology/TechnologyManagement">生产技术管理</el-menu-item>
             </el-menu-item-group>

             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(276)" index="/assets/productionTaskManagement">生产任务管理</el-menu-item>
             </el-menu-item-group>

              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(282)" index="/assets/equipmentDesign">设备检测数据</el-menu-item>
              </el-menu-item-group>

              <el-menu-item-group>
                <!-- 临时写死权限ID，后续由后台补正式菜单权限 -->
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(407)" index="/assets/productionCabinetCheck">换电柜检测数据</el-menu-item>
              </el-menu-item-group>

               <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(290)" index="/assets/Technology/upperComputerVersion">上位机版本</el-menu-item>
              </el-menu-item-group>


        </el-submenu>



        <el-submenu  index="11" v-if="hasPermission(256)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="guanliyuan" style="font-size:26px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">售后管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(257)" index="/assets/afterSales">售后工单</el-menu-item>
             </el-menu-item-group>

             <el-menu-item-group>
                <!-- 临时复用 257 权限，后续由后台补独立菜单/权限ID后再切换 -->
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(410)" index="/assets/cabinetAfterSales">换电柜售后工单</el-menu-item>
             </el-menu-item-group>

             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(294)" index="/assets/saleclassification">售后分类</el-menu-item>
             </el-menu-item-group>
        </el-submenu>




           <el-menu-item index="/assets/order" class="firstmenus"  v-if="hasPermission(8)">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="order" style="font-size: 32px" ></svg-icon>
                  </div>
                  <span style="font-size: 16px;">订单管理</span>
              </div>
        </el-menu-item>
        <el-menu-item index="/assets/stockFinished" class="firstmenus"  v-if="hasPermission(174)">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="order" style="font-size: 32px" ></svg-icon>
                  </div>
                  <span style="font-size: 16px;">成品库存管理</span>
              </div>
        </el-menu-item>



         <el-submenu index="8"  v-if="hasPermission(9)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="xitong" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">系统管理</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(86)" index="/assets/systemSet/accountAdmin/index">账号管理</el-menu-item>
             </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(87)" index="/assets/systemSet/roleAdmin/index">角色管理</el-menu-item>
             </el-menu-item-group>
        </el-submenu>
          <!-- <el-menu-item style="padding-left:30px;"  class="firstmenus" index="/assets/simCardList">
             <div style="display:flex">
                <svg-icon icon-class="sim" style="font-size:26px;marginTop:15px;"></svg-icon>
                <span slot="title" style="marginLeft:12px;">SIM卡管理</span>
              </div>
          </el-menu-item>
          <el-menu-item style="padding-left:30px;"  class="firstmenus" index="/assets/fundsList">
              <div style="display:flex">
                  <svg-icon icon-class="dingjia" style="font-size:26px;marginTop:15px;"></svg-icon>
                  <span slot="title" style="marginLeft:12px;">续费订单管理</span>
              </div>
          </el-menu-item>
          <el-menu-item style="padding-left:30px;"  class="firstmenus" index="/assets/earlyList">
               <div style="display:flex">
                   <svg-icon icon-class="yujing" style="font-size:26px;marginTop:15px;"></svg-icon>
                  <span slot="title" style="marginLeft:12px;">预警管理</span>
                </div>
          </el-menu-item> -->

        </el-menu>
      </el-aside>
    </el-container>
  </div>
</template>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  .icon-wrap {
    display: flex;
    align-items: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    padding-right: 10px;
    [data-theme="theme1"] & {
      color: #00f7ef;
    }
    [data-theme="theme2"] & {
      color: #fff;
    }
    [data-theme="theme2_skyblue"] & {
      color: #0060aa;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  inject: ["reload"], // 注入重载的功能（注入依赖）
  computed: {
    ...mapGetters(["theme"]),
  },

  data() {
    return {


    };
  },

  methods: {
    //权限控制
    hasPermission(id) {
      // console.log(id,"id")
      return this.$store.getters.hasPermission(id);
    },
    // showBG(){
    //     return this.theme=="" || this.theme=="theme1"
    // },

    refs(name) {
      var that = this;
      that.$emit("listnone", name);
    },
    handleselect: function (a, b, index) {
      this.reload(); // 点击侧边栏重新载入页面
      // console.log(a)
      // console.log(index.itemStyle)
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClick() {},
  },
  //重写点击菜单的跳转方法
  // async mounted() {
  //     this.$refs.menus.routeToItem=(item)=>{
  //         let route = item.route || item.index;
  //         try {
  //             this.toCachePage({path:route});
  //         } catch (e) {
  //             console.error(e);
  //         }
  //      //   this.toCachePage({path:item})
  //     }
  // },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue